module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-row clickable",
    on: {
      "click": function($event) {
        _vm.editing = !_vm.editing
      }
    }
  }, [(_vm.default_options.checkbox) ? _c('div', {
    staticClass: "table-col table-col-collapsed no-padding"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": _vm.toggleSelected
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selected
    }
  }), _c('label', [_vm._v(" ")])])]) : _vm._e(), _c('div', {
    staticClass: "table-col text-gray-color",
    class: {
      'no-padding': _vm.default_options.checkbox
    }
  }, [_vm._v(_vm._s(_vm.tag.name))]), _c('div', {
    staticClass: "table-col"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('tag', {
    attrs: {
      "tag": _vm.tag
    }
  })], 1)])]), (_vm.default_options.can_edit && _vm.editing) ? _c('div', {
    staticClass: "table-row template"
  }, [_c('div', {
    staticClass: "table-col table-col-200"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('color-input', {
    model: {
      value: (_vm.color),
      callback: function($$v) {
        _vm.color = $$v
      },
      expression: "color"
    }
  })], 1)]), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Salvar")]), _c('span', {
    staticClass: "spacer-15"
  }), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroyTag
    }
  }, [_vm._v("Excluir")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1aae452a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tags/list_item.vue
// module id = 1030
// module chunks = 1